export default [
  { id: "only_once", name: "Items can bought only once" },
  { id: "instant_checkout_only", name: "Instant-Checkout only" },
  { id: "mailing_list", name: 'Provide "Mailinglist-option" in checkout' }
];
